import { Pipe, PipeTransform } from '@angular/core';
import { BzApteka } from '../interfaces/bz-apteka';
import { LocalizationService } from '@core/services';
import { OrderLocalStorageService } from 'src/app/core/services/storage.services/order-local-storage.service';
import { IOrderIdWithDate } from '../interfaces/order-id-with-date.model';
import { environment } from '@env';

@Pipe({
    name: 'getLinkForOrderSharing'
})
export class GetLinkForOrderSharingPipe implements PipeTransform {

    constructor(
        private readonly locale: LocalizationService,
        private readonly orderLocalStorageService: OrderLocalStorageService,
    ) { }

    transform(apteka: BzApteka): string {
        const prefix = this.locale.getLang() === 'ua' ? 'ua' : '';
        const ordersState: IOrderIdWithDate[] = JSON.parse(this.orderLocalStorageService.ordersHistoryIdsWithDate);
        const targetOrder = ordersState.find((order) => order.id === apteka.order.id);
        if (targetOrder) {
            return `${environment.baseUrl}/${prefix}?orderId=${targetOrder.id}&timestamp=${targetOrder.timestamp}`;
        }
        return `${environment.baseUrl}/${prefix}`;
    }

}
